<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import ResourceFormFields from '@components/resources/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, Trash2, FileDown, ChevronLeft, Globe } from 'lucide-svelte'

  let { resource, tags = [] } = $props()

  let file = $state(null)
  let cover_image = $state(null)
  let useUrl = $state(false)

  $effect(() => {
    file = resource?.file || null
    cover_image = resource?.cover_image || null
    if (resource?.url) useUrl = true
  })

  const form = useForm({
    name: resource?.name || '',
    color: resource?.color || 'gray',
    url: resource?.url || '',
    description: resource?.description?.html || '',
    tag_ids: resource?.tag_ids || [],
  })

  const deleteForm = useForm({})

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => {
      const res = { ...data }
      if (useUrl) {
        res.purge_file = true
      } else {
        res.url = ''
        if (file?._new) res.file = file.file
      }
      return {
        resource: res,
        cover_image: cover_image?._new ? cover_image.file : undefined,
        purge_cover_image: !cover_image ? true : undefined,
      }
    })
    $form.put(`/admin/resources/${resource.id}`, {
      onSuccess: () => router.visit('/admin/resources'),
    })
  }

  function handleDelete() {
    if (!window.confirm("Are you sure you want to delete this resource?")) return
    $deleteForm.delete(`/admin/resources/${resource.id}`, {
      onSuccess: () => router.visit('/admin/resources'),
    })
  }

  let navigationProps = {
    title: resource?.name || "Edit resource",
    Icon: FileDown,
    links: [{ text: "Admin", href: "/admin" }, { text: "Resources", href: "/admin/resources" }],
  }
</script>

<Page.Layout title={resource?.name || "Edit resource"}>

  <Page.Navigation {...navigationProps} />

  <Page.Titles title={resource?.name || "Edit resource"} subtitle="Edit this resource">
    {#snippet buttons()}
      <Button text="Back" path="/admin/resources" BeforeIcon={ChevronLeft} />
      <Button variant="warning" text="Delete" Icon={Trash2} onclick={handleDelete} loading={$deleteForm.processing} />
      <Button type="submit" form="resource-form" text="Update" variant="submit" Icon={Save} loading={$form.processing} />
      <Button path={`/resources/${resource.id}`} Icon={Globe} hint="View resource" />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="resource-form" onsubmit={handleSubmit}>
    <ResourceFormFields {form} {resource} bind:file bind:cover_image bind:useUrl />
  </Form.Element>

</Page.Layout>
